import React from 'react';

function PageInfo(props) {
  return (
    <div>
      <>
        <div className="titles">
          <h3 className='title'>Setup</h3>
          <p className='commit'>My minimalistic setups</p>
        </div>
      </>
    </div>
  );
}

export default PageInfo;